import { SxProps, Theme } from '@mui/material/styles';

import { getMonthWeeksMinHeightPx } from '@/shared/ui/calendarMonthMinHeight';

const MONTH_WEEKS_MIN_HEIGHT_PX = getMonthWeeksMinHeightPx(40);

export const dayCalendarSx: SxProps<Theme> = {
  width: '100%',
  height: 'auto !important',
  maxHeight: 'none !important',
  overflow: 'visible',
  '& .MuiPickersDay-root, & .MuiDayCalendar-weekDayLabel': {
    fontFamily: 'Neue Frutiger World',
    fontStyle: 'normal',
  },
  '& .MuiDayCalendar-header': {
    justifyContent: 'space-between',
    marginBottom: '8px',
  },
  '& .MuiDayCalendar-weekDayLabel': {
    width: '40px',
    height: '20px',
    fontSize: '12px',
    lineHeight: 1.25,
    color: (theme) => theme.palette.grey[700],
  },
  '& .MuiDayCalendar-weekContainer': {
    gap: '4px',
    marginBottom: 0,
  },
  '& .MuiDayCalendar-weekContainer:not(:last-of-type)': {
    marginBottom: '8px',
  },
  '& .MuiPickersDay-hiddenDaySpacingFiller': {
    width: '44px',
    height: '40px',
    margin: 0,
  },
  '& .MuiDayCalendar-monthContainer': {
    position: 'static',
    height: 'auto',
    minHeight: `${MONTH_WEEKS_MIN_HEIGHT_PX}px`,
    overflow: 'visible',
  },
  '& .MuiDayCalendar-slideTransition': {
    height: 'auto',
    minHeight: `${MONTH_WEEKS_MIN_HEIGHT_PX}px`,
    overflow: 'visible',
  },
  '& .MuiPickersDay-root': {
    color: (theme) => theme.palette.grey[950],
  },
};
